/**
 * Токены живут в localStorage под своими ключами трекера: CRM и трекер
 * открываются в соседних вкладках одного домена, и общий ключ означал бы, что
 * вход в одном приложении молча подменяет сессию в другом.
 *
 * Читать и писать их приходится и мимо стора — из интерцептора axios, который
 * поднимается раньше pinia.
 */
const ACCESS_KEY = 'tracker-access-token'
const REFRESH_KEY = 'tracker-refresh-token'

export interface StoredTokens {
  accessToken: string | null
  refreshToken: string | null
}

export const readTokens = (): StoredTokens => ({
  accessToken: localStorage.getItem(ACCESS_KEY),
  refreshToken: localStorage.getItem(REFRESH_KEY),
})

export const writeTokens = (tokens: { accessToken: string; refreshToken: string }) => {
  localStorage.setItem(ACCESS_KEY, tokens.accessToken)
  localStorage.setItem(REFRESH_KEY, tokens.refreshToken)
}

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
}
